var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 77,
    viewBox: "0 0 49 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scroll_button",
    "data-name": "scroll button",
    transform: "translate(-994 -628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    transform: "translate(994 628)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 77,
    rx: 24.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 46,
    height: 74,
    rx: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y2: 12.111,
    transform: "translate(1018.654 644.868)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollButton);
export default __webpack_public_path__ + "static/media/scroll-button.e100da4cfb2872f4559a2c134276308e.svg";
export { ForwardRef as ReactComponent };